import { useSelector } from 'react-redux';

// Returns the "{eventId}-{studentId}" composite key for attributing a voucher
// purchase to the currently selected student. Unlike useCurrentOrderStudentId,
// this does NOT require a regular-product order to already exist in Redux —
// parents frequently add a voucher before any regular products, and the key
// is resolved server-side against orders in the container at checkout.
export const useCurrentVoucherOrderKey = () => {
  const selectedStudentId = useSelector(
    (state) => state.additionalData.selectedStudent?.id,
  );

  const shootEventId = useSelector((state) => {
    const s = state.shoot.shoot;
    return s?.event_id || s?.id;
  });

  if (!shootEventId || !selectedStudentId) return null;

  return `${shootEventId}-${selectedStudentId}`;
};
